<template>
    <img alt="" src="/recommended.svg" />
</template>
<script>
    import {Component, Vue} from 'nuxt-property-decorator'

    @Component
    export default class RecommendedIcon extends Vue {}
</script>
